import {
  Observable,
  UnaryFunction,
  defer,
  delay,
  map,
  of,
  pipe,
  switchMap,
  timer,
} from 'rxjs';

/**
 * Useful for showing/hiding loaders without glitching
 * If value is truthy, emit it after a tolleranceMS preventing loaders to show up when the response is very fast
 * If value is falsy, emit it after a thresholdMs allowing loaders to persist for the given minimum time without glitching
 * Example n1: True value comes in (tollerance timer starts, nothing is emitted) => False value comes in before tollerance is finished (False is emitted after thresholdMs)
 * Example n2: True value comes in (tollerance timer starts, nothing is emitted) => Tollerance timer elapses (True is emitted) => False value comes in (False is emitted after thresholdMs)
 * @param afterMs delay ms for truthy values
 * @param minimumMs threshold ms for falsy values
 * @returns boolean
 */
export const debounceLoad = (
  afterMs: number = 100,
  minimumMs: number = 500,
): UnaryFunction<Observable<boolean>, Observable<boolean>> =>
  pipe(
    switchMap((res) =>
      defer(() =>
        res
          ? timer(afterMs).pipe(map((_) => res))
          : of(res).pipe(delay(minimumMs)),
      ),
    ),
  );
